import { Component, inject, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';
import { PiExclusion } from '@models/mips-stepper.model';

interface ExclusionModalData {
  measureTitle: string;
  exclusions: PiExclusion[];
  selectedExclusionId: string | null;
}

@Component({
  selector: 'app-pi-exclusion-modal',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatRadioModule,
    MatIconModule,
  ],
  templateUrl: './pi-exclusion-modal.component.html',
  styleUrls: ['./pi-exclusion-modal.component.css'],
})
export class PiExclusionModalComponent {
  private readonly dialogRef = inject(MatDialogRef<PiExclusionModalComponent>);
  
  measureTitle: string;
  exclusions: PiExclusion[];
  selectedExclusionId: string | null;

  constructor(@Inject(MAT_DIALOG_DATA) public data: ExclusionModalData) {
    this.measureTitle = data.measureTitle;
    this.exclusions = data.exclusions;
    this.selectedExclusionId = data.selectedExclusionId;
  }

  cancel(): void {
    this.dialogRef.close();
  }

  save(): void {
    this.dialogRef.close(this.selectedExclusionId);
  }

  removeExclusion(): void {
    this.dialogRef.close(null);
  }
}